/**
 * ==== 文件管理 ====
 */

// 删除上传文件
export const REMOVE_UPLOAD_FILE = "REMOVE_UPLOAD_FILE";


// WEBPACK FOOTER //
// ./src/constants/file.js